<div class="pageTitle">
  {{ 'Select Amount' | translate }}
</div>

<form (ngSubmit)="onSubmit()" #f="ngForm" novalidate>
  <div [loading]="isLoading" class="loading-pContent">
    <div class="pContent">
      <div class="groupTitle">
        <strong>{{ bank.bankName | beautifulEnum }}</strong>
        <span *ngIf="isBankChangeable"
          ><a href="#" (click)="change()">{{ 'Change' | translate }}</a></span
        >
      </div>
      <div class="listedOption grid stForm" [class.mb-5]="cancelRedirectUrl">
        <div class="item" *ngFor="let item of amounts">
          <input
            type="radio"
            id="option-{{ item.activeAmountId }}"
            name="amount"
            [(ngModel)]="selectedAmount"
            [value]="item"
            required
          />
          <label for="option-{{ item.activeAmountId }}">
            <span>{{
              item.amount | currency: item.currency : 'symbol-narrow'
            }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="pButton">
    <ng-container *ngIf="cancelRedirectUrl">
      <button class="btn bg-white" (click)="backToMerchant()">
        {{ 'Cancel' | translate }}
      </button>
    </ng-container>

    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="f.invalid || isLoading"
    >
      {{ 'Continue' | translate }}
    </button>
  </div>
</form>
